import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isEmailVerified, isSetupCompleted, user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Yükleniyor...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!isEmailVerified) {
    return <Navigate to="/verify-email-notice" replace />;
  }

  // Kurulum kontrolü
  if (!isSetupCompleted) {
    // Kullanıcı yönetici veya office_owner ise setup sayfasına yönlendir
    const isManager = user?.is_manager || user?.role === 'office_owner';
    
    if (isManager) {
      // Zaten setup sayfasındaysa tekrar yönlendirme
      if (location.pathname === '/setup') return children;
      return <Navigate to="/setup" replace />;
    } else {
      // Personel ise bekleme sayfasına yönlendir
      if (location.pathname === '/setup-pending') return children;
      return <Navigate to="/setup-pending" replace />;
    }
  }

  // Kurulum tamamlanmışsa setup sayfalarına erişimi engelle
  if (isSetupCompleted && (location.pathname === '/setup' || location.pathname === '/setup-pending')) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;

